import React from "react";
import { Grid, Typography } from "@mui/material";
import AttendanceDashboard from "src/features/attendance/components/AttendanceDashboard";
import { ViewBase } from "src/app/components/ViewBase";

const OverviewView = () => {
  return (
    <ViewBase>
      <Typography variant="h2" sx={{ mb: 4, mt: 2 }}>
        מבט על
      </Typography>
      <Grid item xs={12}>
        <AttendanceDashboard />
      </Grid>
    </ViewBase>
  );
};

export default OverviewView;
